// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3b3d4375","977":"dee169d5"}[chunkId] + ".chunk.js";
};